// extracted by mini-css-extract-plugin
export default {"popup":"gn_go","popup__content":"gn_gp","popup__content_headerless":"gn_gq","popup__header":"gn_gr","popup__close":"gn_gs","popup__reconnecting":"gn_gt","rotate":"gn_gu"};